export const selectShouldOpen = ({ toastNotification }) => toastNotification.shouldOpen;
export const selectNotificationText = ({ toastNotification }) => toastNotification.notificationText;
